import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=15bdcb8b&scoped=true&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=15bdcb8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bdcb8b",
  null
  
)

export default component.exports